export default {
  title: 'Contact',
  sections: {
    contact_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">Contact</div>Engineering the future together',
            text2: 'Challenge us with your specific <br/> concerns. Let’s get to know each other <br/> in a conversation with no obligations.',
            image: '/seu/latest-assets/seu_28.jpg',
          }
        },
      }
    },
    contact_contact_section: {
      fields: {
        field_one: {
          value: {
            title: 'What challenge are you facing?',
            subTitle: 'We’re looking forward to hearing from you.<br>You can be assured of the utmost discretion<br>and confidentiality.',
            buttonLabel: 'Call us',
            buttonLabel2: 'Write to us',
            image: '/seu/latest-assets/seu_36.jpg',
            link1: 'tel:+41 (0)58 521 19 00',
            link2: 'mailto:verwaltungsrat@seu.ch'
          }
        },
      }
    },
    contact_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Contact'
          }
        }
      }
    },
    contact_text_section: {
      fields: {
        field_one: {
          value: {
            text: '<span class="text-highlight">make an<br/> appointment</span>',
            text2: 'Two heads – or three or four –<br> are better than one. Let’s find<br> solutions together.'
          }
        },
        field_three: {
          value: {
            text: 'We offer answers – forward looking, informed by experience and<br> without delay.',
            text2: 'You have big plans and hope to find a reliable partner? You’re looking for a successor but don’t know how to proceed?',
            buttonLabel : 'book now online',
            buttonIconLeft: '/seu/arrow-right.svg'
          }
        },
      }
    },
    contact_info_section: {
      fields: {
        field_one: {
          value: {
            title: 'CONTACT US',
            text: 'We look forward to hearing from you and discovering together how we can help you with the future development of your engineering firm.<br> <br> Here you\'ll find our contact information as well as detailed travel directions, which will be helpful when planning a visit.',
            location: 'Churerstrasse 54 CH-8808 Pfäffikon SZ',
            number: '+41 (0)58 521 19 00',
            website: 'www.seu.ch',
            email: 'info@seu.ch',
            linkedin: 'LinkedIn',
            icon1: '/seu/latest-icons/contact/location-black.svg',
            icon2: '/seu/latest-icons/contact/phone-black.svg',
            icon3: '/seu/latest-icons/contact/website-black.svg',
            icon4: '/seu/latest-icons/contact/mail-black.svg',
            icon5: '/seu/latest-icons/contact/linkedin-black.svg',
            buttonIcon: '/seu/location-white.svg',
            buttonLabel: 'SHOW ON GOOGLE MAPS',
            buttonIcon2: '/seu/direction.svg',
            buttonLabel2: 'DIRECTIONS',

          }
        },
      }
    },
    contact_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Contact'
          }
        }
      }
    },
    contact_text_2_section: {
      fields: {
        field_one: {
          value: {
            text: '<span class="text-highlight">Business presentation </span>',
            text2: 'Meeting up on an equal basis'
          }
        },
        field_three: {
          value: {
            text: 'Before contacting us and getting to know us personally, would you like to get more information about us?',
            text2: 'We’re happy to oblige. We know what questions are on your mind and we have compiled our answers for you. <a class="text-highlight">Download our short presentation here</a>.',
            buttonLabel: 'Download pdf',
            buttonIconLeft: '/seu/arrow-right.svg'
          }
        },
      }
    },
  }
}
